export const principalAssets = [
    'alarm',
    'ac',
    'upstairs',
    'elevator',
    'policeman',
    'cave',
    'fireplace',
    'dressing',
    'sport',
    'spa',
    'accessibility', // asset only on web for now
];

export const additionalAssets = ['balcony', 'garage', 'view', 'pool', 'terrace', 'yard', 'garden', 'veranda'];

export const allAssets = [...principalAssets, ...additionalAssets];

// WARNING : List from mobile repo, make sur to d'ont change names to make web and mobile working together !!!
// const List<String>adPropertyAssets =[
//     'alarm',
//     'elevator',
//     'cave',
//     'fireplace',
//     'ac',
//     'dressing',
//     'upstairs',
//     'policeman',
//     'spa',
//     'balcony',
//     'yard',
//     'garage',
//     'pool',
//     'garden',
//     'sport',
//     'terrace',
//     'veranda',
//     'view',
// ];
